import React, { Fragment, Component } from 'react';
import { inject } from 'mobx-react';

import { localizable } from 'components/Localization';
import RoundDateDisplay from 'components/RoundDateDisplay';
import Money from 'components/Money';

@inject('app')
@localizable
class SaleWizardRoundInfo extends Component {
  render() {
    const { round, t } = this.props;

    return (
      <Fragment>
        <div
          className="ms-font-l ms-fontWeight-semibold"
          style={{ color: '#003da5' }}
        >
          {t(`roundtype::${round.type}`)}
        </div>

        <div>
          {t('Ends')}:{' '}
          <RoundDateDisplay
            end={round.endsAt}
            duration={round.durationInDays}
          />
        </div>
        {(!!round.offerValidityUntil || !!round.offerValidityInDays) && <div>
          {t('Offer validity')}:{' '}
          <RoundDateDisplay
            end={round.offerValidityUntil}
            duration={round.offerValidityInDays}
          />
        </div>}

        {round.estimate && (
          <div>
            {t('Estimate')}:{' '}
            <Money
              value={round.estimate}
              currency={this.props.app.currency.code}
              locale={this.props.intl.locale}
            />
          </div>
        )}
        {round.startPrice && (
          <div>
            {round.type === 'sealed_bidding'
              ? t('Minimum price')
              : t('Start price')}
            :{' '}
            <Money
              value={round.startPrice}
              currency={this.props.app.currency.code}
              locale={this.props.intl.locale}
            />
          </div>
        )}
        {round.redButtonPrice && (
          <div>
            {t('Red button price')}:{' '}
            <Money
              value={round.redButtonPrice}
              currency={this.props.app.currency.code}
              locale={this.props.intl.locale}
            />
          </div>
        )}
      </Fragment>
    );
  }
}

export default SaleWizardRoundInfo;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/components/RoundInfo.jsx